module.exports = __webpack_public_path__ + "img/title.a6c3542e.png";